// extracted by mini-css-extract-plugin
export var quantityInput = "_nf-0";